<template>
  <v-item class="flex-grow-1" v-slot="{ active, toggle }" :value="value">
    <v-card
      :class="['course-type__card', active && 'course-type__card--selected']"
      flat
      :color="active ? '#007DFF1F' : '#f5f5f5'"
      @click.native="toggle"
    >
      <v-icon size="64" :color="active ? 'primary' : undefined">{{ icon }}</v-icon>
      <BaseTypography variant="subtitle-3">
        {{ text }}
      </BaseTypography>
    </v-card>
  </v-item>
</template>

<script>
import BaseTypography from '@/component/Base/base-typography';

export default {
  name: 'CourseTypeCard',
  components: {
    BaseTypography,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.course-type {
  &__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    gap: 8px;
    border: 2px solid #f5f5f5 !important;

    border-radius: 8px !important;

    &--selected {
      border: 2px solid #007dff !important;
    }
  }
}
</style>
